import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import BackgroundImage from '../../assets/bg_white_hills.png';
import Confetti from '../../assets/bg_confetti_big.png';
import ActivityHeader from './ActivityHeader';
import ActivityGridItem from './ActivityGridItem';
import {useTranslation} from 'react-i18next';
import {mobileMediaQuery, notWebMediaQuery, useIsMobile} from '../../styles';
import ActivityGridMore from './ActivityGridMore';

const CartoonitoParentalActivities = props => {
    const {t} = useTranslation();

    useEffect(() => {
        handleWindowResize();

        window.addEventListener('resize', handleWindowResize);

        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
        // eslint-disable-next-line
    }, []);

    const [gridSize, setGridSize] = useState(3);
    const [cardWidth, setCardWidth] = useState(0);

    const handleWindowResize = () => {
        const windowWidth = window.innerWidth;

        if (windowWidth <= 1024) {
            setGridSize(2);
            setCardWidth((windowWidth - 32 - 15) / 2);
        } else {
            setGridSize(3);
            setCardWidth(328);
        }
    };

    const isMobile = useIsMobile();

    return (
        <Container>
            <Anchor id="activities" />
            <Hills />
            <ContentContainer>
                <TitleText>{t('parentalPage.activities.title')}</TitleText>
                {props.activities && props.activities.length && (
                    <Grid>
                        {gridSize === 3 && (
                            <ActivityHeader
                                activity={props.activities[0]}
                                gridSize={gridSize}
                            />
                        )}
                        {props.activities
                            .slice(gridSize === 3 ? 1 : 0)
                            .map((activity, index) => (
                                <ActivityGridItem
                                    activity={activity}
                                    key={String(index)}
                                    width={cardWidth}
                                />
                            ))}
                        {!isMobile && <ActivityGridMore />}
                    </Grid>
                )}
            </ContentContainer>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    background-color: #f7f7f7;

    flex-direction: column;
    padding-bottom: 150px;
    background-image: url(${Confetti});
    background-position: center 0px;
`;

const Hills = styled.div`
    background-image: url(${BackgroundImage});
    background-repeat: repeat-x;
    margin-top: -10px;
    display: flex;
    height: 50px;
`;

const ContentContainer = styled.div`
    display: flex;
    margin-top: 25px;
    flex-direction: column;
    max-width: 1016px;
    align-self: center;
    flex: 1;
    width: 100%;

    ${mobileMediaQuery} {
        margin-top: 0px;
    }
`;

const TitleText = styled.div`
    font-family: Rodger;
    font-weight: 900;
    font-size: 26px;
    color: black;
    text-transform: uppercase;
    margin-bottom: 20px;

    ${notWebMediaQuery} {
        padding: 0px 25px;
        margin-bottom: 0px;
    }
    ${mobileMediaQuery} {
        font-size: 21px;
    }
`;

const Grid = styled.div`
    display: grid;
    grid-template-columns: 328px 328px 328px;
    grid-gap: 0px 15px;

    ${notWebMediaQuery} {
        grid-template-columns: 1fr 1fr;
        padding: 0px 16px;
    }
`;

const Anchor = styled.a`
    display: block;
    position: relative;
    top: -150px;
    visibility: hidden;
`;

export default CartoonitoParentalActivities;
